import i18n from 'i18next';

// Its own namespace: AppRouter and RouteSkeleton draw the skeleton, so it is in the initial
// bundle and must not pull the feature's copy (../../i18n) in with it.
export const NS = 'learning-skeleton';

export const en = {
  home: 'Loading Learning',
  stage: 'Loading the stage',
  news: "Loading what's new",
  mcp: 'Loading the MCP server guide',
  releases: 'Loading the release notes',
};
export const es: typeof en = {
  home: 'Cargando Learning',
  stage: 'Cargando la etapa',
  news: 'Cargando las novedades',
  mcp: 'Cargando la guía del servidor MCP',
  releases: 'Cargando las notas de versión',
};
export const pt: typeof en = {
  home: 'Carregando o Learning',
  stage: 'Carregando a etapa',
  news: 'Carregando as novidades',
  mcp: 'Carregando o guia do servidor MCP',
  releases: 'Carregando as notas de versão',
};

// Guarded so importing this is safe where the i18next singleton isn't initialized (jest).
if (typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('en', NS, en, true, true);
  i18n.addResourceBundle('es', NS, es, true, true);
  i18n.addResourceBundle('pt', NS, pt, true, true);
}
